export interface PostgreSQLConnectionFields {
  host: string;
  port: string;
  database: string;
  username: string;
  password: string;
}

export function validatePostgreSQLFields(fields: PostgreSQLConnectionFields, retainCredentials = false) {
  const errors: Partial<Record<keyof PostgreSQLConnectionFields, string>> = {};
  if (!fields.host.trim()) errors.host = 'Enter the database hostname.';
  if (!/^\d+$/.test(fields.port) || Number(fields.port) < 1 || Number(fields.port) > 65535) {
    errors.port = 'Enter a whole number between 1 and 65535.';
  }
  if (!fields.database.trim()) errors.database = 'Enter the database name.';
  if (!retainCredentials && !fields.username.trim()) errors.username = 'Enter the database username.';
  if (!retainCredentials && !fields.password) errors.password = 'Enter the database password.';
  return errors;
}